<template>
  <div class="detection-events-container">
    <p class="lead text-center font-medium-3">
      {{detEvent.alarm_type}}
    </p>
    <div class="detection-events-list" ref="scrollContainer">
      <div
        v-for="(value, key) in ovnifEvents"
        :key="`detection-item-${key}`"
        class="detection-event-item"
        :ref="`item-${key}`"
      >
        <div
          class="loading-container"
          v-if="value == ''"
        >
          <b-spinner variant="primary" class="loading-spinner"></b-spinner>
        </div>
        <detectionEvent-data
          v-else
          :key="`detectionEvent-data-${key}-`"
          :ovnifData="value"
          :index="key"
          :isLastOne="key === totalEvents - 1"
        />
      </div>
    </div>
  </div>
</template>
<script>
import DetectionEventData from "./DetectionEventData.vue";
import axios from "@axios";
import { BButton } from "bootstrap-vue";

export default {
  components: {
    "detectionEvent-data": DetectionEventData,
    BButton,
  },
  props: {
    detEvent: Object,
    idAlarm: Number,
  },
  data() {
    return {
      ovnifEvents: [],
      totalEvents: 0,
      observer: null,
      loadedItems: new Set(),
    };
  },
  methods: {
    async loadDetectionEvent(index) {
      if (this.loadedItems.has(index) || this.ovnifEvents[index] !== '') return;

      this.loadedItems.add(index);

      try {
        const response = await axios.post(`${window.__env.VUE_APP_BASE_URL}/v1/services/detection-events/get-events-by-alarm-id`, {
          alarmId: this.$props.idAlarm,
          index: index,
        });
        const resData = response.data;
        this.$set(this.ovnifEvents, index, resData);
      } catch (error) {
        console.error("Error loading detection event:", error);
        this.loadedItems.delete(index);
      }
    },
    setupIntersectionObserver() {
      if (!('IntersectionObserver' in window)) {
        for (let i = 1; i < this.totalEvents; i++) {
          this.loadDetectionEvent(i);
        }
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.index);
            if (!isNaN(index)) {
              this.loadDetectionEvent(index);
            }
          }
        });
      }, {
        root: this.$refs.scrollContainer,
        rootMargin: '100px',
        threshold: 0.1
      });

      this.$nextTick(() => {
        for (let i = 1; i < this.totalEvents; i++) {
          const element = this.$refs[`item-${i}`];
          if (element && element[0]) {
            element[0].dataset.index = i;
            this.observer.observe(element[0]);
          }
        }
      });
    },
  },  async mounted() {
    this.totalEvents = this.$props.detEvent.detection_event_data.total_events;

    for (let index = 0; index < this.totalEvents; index++) {
      this.ovnifEvents[index] = "";
    }

    try {
      const response = await axios.post(`${window.__env.VUE_APP_BASE_URL}/v1/services/detection-events/get-events-by-alarm-id`, {
        alarmId: this.$props.idAlarm,
        index: 0,
      });
      const resData = response.data;
      this.$set(this.ovnifEvents, 0, resData);
      this.loadedItems.add(0);

      if (this.totalEvents > 1) {
        this.setupIntersectionObserver();
      }
    } catch (error) {
      console.error("Error loading first detection event:", error);
    }
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },

};
</script>
<style scoped>
.detection-events-container {
  width: 100%;
}

.detection-events-list {
  max-height: 400px;
  overflow-y: auto;
  padding: 10px;
}

.detection-event-item {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #f9f9f9;
}

.detection-event-item:last-child {
  margin-bottom: 0;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
}

.loading-spinner {
  margin-top: 20px;
}

.dark-layout .detection-event-item {
  background-color: var(--main-dark);
}
</style>
